import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { PlannerBucketsComponent } from '../planner-buckets/planner-buckets.component';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { sweetAlert } from 'src/app/utils/swal';
import { CorporateService } from 'src/app/component/corporate-user/corporate-service/corporate-service';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-planner-buckets-wrapper',
  templateUrl: './planner-buckets-wrapper.component.html',
  styleUrls: ['./planner-buckets-wrapper.component.css']
})
export class PlannerBucketsWrapperComponent implements OnInit, OnDestroy {
  @ViewChild('bucket', { static: false }) bucket: PlannerBucketsComponent;
  @Input() drivers;
  @Input() trips;
  @Input() compatibleTrips;
  @Input() staff;
  @Input() date;
  @Input() shifts;
  @Input() algorithmType: any = false;
  user;
  timeZone;
  constructor(
    private sharedDataService: SharedDataService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private serviceArea: ServiceAreasService,
  ) { }


  ngOnInit() {
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
        }
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.bucket.getLevelOfService(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.bucket.getSpaceTypes(data);
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.bucket.getCorporate(data);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.bucket.getServiceAreas(data);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getAllTrips() {
    const payload = {
      drivers :this.drivers,
      trips: this.trips,
      compatibleTrips: this.compatibleTrips,
      staff: this.staff,
      date: this.date,
      algorithmType: this.algorithmType
    }
    this.bucket.getAllTrips(payload)
  }
  getDrivers() {
    this.bucket.getDriverList(this.drivers);
    this.bucket.getShifts(this.shifts);
  }

  ngOnDestroy(): void {
  }


}
